module.exports = __webpack_public_path__ + "static/media/4.075a8f3e.jpg";